// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"447":"e0bcaeec","967":"d87ccda2"}[chunkId] + ".chunk.js";
};